export default {
  title: 'Delivery',
  packaged: {
    title: 'How is the medication packaged?',
    description: 'We deliver your prescription in plain & tamper-proof packaging. If there are any visible signs of damage or tampering to the external packaging, please do not accept delivery and immediately contact us.',
  },
  secure: {
    title: 'Is the delivery secure?',
    description: 'Patient safety is our highest priority, so we will not be able to hand over medication without receiving a delivery confirmation code from you in-person. We can alternatively accept any form of valid ID providing the named individual matches the addressee details on the prescription order.',
  },
};
